import { render, staticRenderFns } from "./PushTxnList.vue?vue&type=template&id=efce5a30&scoped=true"
import script from "./PushTxnList.vue?vue&type=script&lang=js"
export * from "./PushTxnList.vue?vue&type=script&lang=js"
import style0 from "./PushTxnList.vue?vue&type=style&index=0&id=efce5a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efce5a30",
  null
  
)

export default component.exports